var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hotmail = exports["default"] = void 0;
var hotmail = ["hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.be", "hotmail.com.br", "hotmail.ca", "hotmail.cz", "hotmail.cl", "hotmail.dk", "hotmail.fi", "hotmail.fr", "hotmail.gr", "hotmail.de", "hotmail.com.hk", "hotmail.hu", "hotmail.co.in", "hotmail.co.id", "hotmail.co.il", "hotmail.it", "hotmail.co.jp", "hotmail.co.kr", "hotmail.lv", "hotmail.lt", "hotmail.my", "hotmail.nl", "hotmail.no", "hotmail.ph", "hotmail.rs", "hotmail.sg", "hotmail.sk", "hotmail.co.za", "hotmail.es", "hotmail.se", "hotmail.com.tw", "hotmail.co.th", "hotmail.com.tr", "hotmail.com.vn", "hotmail.co.uk"];
exports.hotmail = hotmail;
var _default = hotmail;
exports["default"] = _default;
export default exports;